import { writable, get } from 'svelte/store';
import { loadActions, loadCategories } from '../api/api';
import { createUrlParamsString, updateUrlParam } from '../../../core/helpers/url.helper';
import { windowPushHistory } from '../../../core/helpers/window.helper';
import { slugify } from '../../../core/helpers/string.helper';
export default class SearchService {
    constructor(dataProvider, tabsProvider) {
        this._dataProvider = dataProvider;
        this._tabsProvider = tabsProvider;
        this._pager = writable({ page: 1, perPage: 6 });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._list = writable([]);
        this._total = writable(0);
        this._error = writable(false);
        this._processing = writable(false);
        this._active = writable(false);
        this._isFilterActive = writable(false);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        this._actionTypes = writable([]);
        this._errorActionTypes = writable(false);
        this._processingActionTypes = writable(false);
        this.submitFromUrl();
    }
    loadActionTypes() {
        this._processingActionTypes.set(true);
        loadCategories(this._dataProvider.groupId)
            .then((response) => {
            this._actionTypes.set(response.results.map(x => {
                return {
                    id: `${x.id}-${slugify(x.nazev)}`,
                    nazev: x.nazev,
                };
            }));
            this._errorActionTypes.set(false);
        })
            .catch(() => this._errorActionTypes.set(true))
            .finally(() => this._processingActionTypes.set(false));
    }
    get actionTypesSubs() {
        return this._actionTypes;
    }
    submitSearch() {
        const params = {
            q: this._dataProvider.searchString,
            typ: this._dataProvider.actionType,
            rozsah: this._dataProvider.dateRange,
        };
        windowPushHistory(createUrlParamsString(params));
        this.setPage(1);
        this._active.set(true);
        this.loadSearchResults();
    }
    goToPage(page) {
        windowPushHistory(updateUrlParam("strana", page));
        this.setPage(page);
        this.loadSearchResults();
    }
    changePageSize(pageSize) {
        windowPushHistory(updateUrlParam("pocet", pageSize));
        this.setPageSize(pageSize);
        this.goToPage(1);
    }
    submitFromUrl() {
        this._dataProvider.searchString = this._dataProvider.searchParameterFromUrl;
        this._dataProvider.actionType = this._dataProvider.typeParameterFromUrl;
        const urlPage = this._dataProvider.pageParameterFromUrl;
        if (urlPage)
            this.setPage(urlPage);
        const urlPageSize = this._dataProvider.pageSizeParameterFromUrl;
        if (urlPageSize)
            this.setPageSize(urlPageSize);
        this._active.set(true);
        this.loadSearchResults();
    }
    loadSearchResults() {
        this._processing.set(true);
        const [actionTypeId, ...actionTypeSlug] = this.dataProvider.actionType.split('-');
        const filterParams = {
            query: this.dataProvider.searchString,
            actionTypeId: actionTypeId || '',
            actionTypeSlug: actionTypeSlug.join('-'),
            dateFrom: this.tabsProvider.getTabPropertyByKey(this.dataProvider.dateRange, 'dateFrom'),
            dateTo: this.tabsProvider.getTabPropertyByKey(this.dataProvider.dateRange, 'dateTo'),
            dateRange: this.dataProvider.dateRange,
            groupId: this.dataProvider.groupId,
            showSiteUrl: this.dataProvider.showSiteUrl,
            pager: this.pager,
        };
        loadActions(filterParams)
            .then((response) => {
            this._list.set(response.results);
            this._pager.set(Object.assign(Object.assign({}, this.pager), { total: response.total }));
            this._total.set(response.total);
            this._error.set(false);
            this._isFilterActive.set(!!(filterParams.query || filterParams.actionTypeId || filterParams.dateRange));
            // @ts-ignore
            setTimeout(() => removeClickFocus(), 100);
        })
            .catch(() => this._error.set(true))
            .finally(() => this._processing.set(false));
    }
    setPage(page) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { page }));
    }
    setPageSize(perPage) {
        this._pager.set(Object.assign(Object.assign({}, this.pager), { perPage }));
    }
    get dataProvider() {
        return this._dataProvider;
    }
    get tabsProvider() {
        return this._tabsProvider;
    }
    get listSubs() {
        return this._list;
    }
    get activeSubs() {
        return this._active;
    }
    get isFilterActiveSubs() {
        return this._isFilterActive;
    }
    get totalSubs() {
        return this._total;
    }
    get errorSubs() {
        return this._error;
    }
    get errorActionTypesSubs() {
        return this._errorActionTypes;
    }
    get processingSubs() {
        return this._processing;
    }
    get processingActionTypesSubs() {
        return this._processingActionTypes;
    }
    get pagerSubs() {
        return this._pager;
    }
    get pager() {
        return get(this._pager);
    }
}
